import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";

const LINKS = [
  { to: "/", label: "Home", id: NAV.links.home, end: true },
  { to: "/about", label: "About", id: NAV.links.about },
  { to: "/competenze", label: "Competenze", id: NAV.links.competenze },
  { to: "/progetti", label: "Progetti", id: NAV.links.progetti },
  { to: "/libro", label: "Libro", id: NAV.links.libro },
  { to: "/contatti", label: "Contatti", id: NAV.links.contatti },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [loc.pathname]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-cream/80 backdrop-blur-xl border-b border-line" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-20 md:h-24">
        <Link
          to="/"
          data-testid={NAV.brand}
          className="font-heading text-2xl md:text-3xl tracking-tight text-ink leading-none"
        >
          Giovanni <span className="italic text-peach">Gabban</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.id}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.22em] transition-colors editorial-link ${
                  isActive ? "text-peach" : "text-ink hover:text-peach"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contatti"
          data-testid={NAV.cta}
          className="hidden md:inline-block text-xs uppercase tracking-[0.22em] border border-ink rounded-full px-5 py-3 hover:bg-ink hover:text-cream transition-colors"
        >
          Scrivimi
        </Link>

        <button
          data-testid={NAV.menuToggle}
          className="md:hidden p-2 -mr-2 text-ink"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-cream border-t border-line">
          <div className="px-6 py-8 flex flex-col gap-6">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`${l.id}-mobile`}
                className={({ isActive }) =>
                  `font-heading text-3xl ${isActive ? "text-peach" : "text-ink"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
